import { ReactNode } from 'react'

export default function SubContainer({
  children,
  className = '',
  header,
}: {
  children: ReactNode
  className: string
  header: string
}): React.ReactElement {
  return (
    <div className={`p-4 rounded shadow-large bg-white/80 backdrop-blur-lg ${className}`}>
      <header className="mb-1 text-transparent">
        <h2 className="text-lg font-bold bg-clip-text bg-gradient-to-r from-purple to-blue-icy">{header}</h2>
      </header>
      {children}
    </div>
  )
}
